/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldMappingDto } from './FieldMappingDto';
import {
    FieldMappingDtoFromJSON,
    FieldMappingDtoFromJSONTyped,
    FieldMappingDtoToJSON,
    FieldMappingDtoToJSONTyped,
} from './FieldMappingDto';

/**
 * 
 * @export
 * @interface PreviewMappingRequestDto
 */
export interface PreviewMappingRequestDto {
    /**
     * 
     * @type {Array<FieldMappingDto>}
     * @memberof PreviewMappingRequestDto
     */
    mappings?: Array<FieldMappingDto> | null;
    /**
     * 
     * @type {string}
     * @memberof PreviewMappingRequestDto
     */
    defaultDateFormat?: string | null;
}

/**
 * Check if a given object implements the PreviewMappingRequestDto interface.
 */
export function instanceOfPreviewMappingRequestDto(value: object): value is PreviewMappingRequestDto {
    return true;
}

export function PreviewMappingRequestDtoFromJSON(json: any): PreviewMappingRequestDto {
    return PreviewMappingRequestDtoFromJSONTyped(json, false);
}

export function PreviewMappingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreviewMappingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'mappings': json['mappings'] == null ? undefined : ((json['mappings'] as Array<any>).map(FieldMappingDtoFromJSON)),
        'defaultDateFormat': json['defaultDateFormat'] == null ? undefined : json['defaultDateFormat'],
    };
}

export function PreviewMappingRequestDtoToJSON(json: any): PreviewMappingRequestDto {
    return PreviewMappingRequestDtoToJSONTyped(json, false);
}

export function PreviewMappingRequestDtoToJSONTyped(value?: PreviewMappingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mappings': value['mappings'] == null ? undefined : ((value['mappings'] as Array<any>).map(FieldMappingDtoToJSON)),
        'defaultDateFormat': value['defaultDateFormat'],
    };
}

